export enum FeedbackRequestTypeName {
  ASK_A_TEACHER = 'ASK_A_TEACHER',
}

export enum FeedbackRequestTypeText {
  ASK_A_TEACHER = 'Ask a Teacher',
}
